export class OauthTypeConfiguration {
  uid: string;
  oauthlnk: string;
  clientid: string;
  clientsecret: string;
  authorizationURL: string;
  accesstokenreq: string;

}
